import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetBonusHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: '',
                url: urls.GET_LIST_HISTORY_BONUSES
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetBonusHistoryListAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetBonusHistoryList as SetGetBonusHistoryList
}